import { useGetMedications } from 'api/generated/medication/medication'
import type { MedicationStaffApiOutContract } from 'api/generated/pwrdbyQuickMDProvidersApi.schemas'

// Wraps the Orval-generated GET /api/v1/medications hook so the data source is
// swappable from one place. Consumers use the generated contract directly —
// Orval is the source of truth, so the frontend type can't drift from the API.
export function useProviderMedications(): { data: MedicationStaffApiOutContract[]; isLoading: boolean } {
  const { data, isLoading } = useGetMedications()
  return { data: data ?? [], isLoading }
}
